<template>
    <v-list-item-group active-class="active-item" color="primary">
      <v-list-item
          v-for="(item, i) in isAuthenticated ? authLinks : links"
          :key="i"
          :to="item.link"
          exact-path
          color="white"
      >
        <v-list-item-content>
          <v-list-item-title class="text-uppercase" style="color: white; font-size: 12px;" v-text="item.text"/>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </template>
  <script>
  import { mapGetters } from "vuex";

  export default {
    name: "LearningSideMenu",
    data: () => ({
      links: [
        {text: 'TUTORS', link: '/tutors', icon: '', isImage: false},
        {text: 'LEARNING MATERIALS', link: '/learning', icon: '', isImage: false},
        {text: 'QUESTIONS /PAST PAPERS', link:"/questions", icon: '', isImage: false},
      ],
    }),
    computed: {
      ...mapGetters({
        isAuthenticated: "auth/GET_IS_AUTHENTICATED",
        user: "auth/GET_USER",
      }),
      fullName() {
        return this.user?.profile?.first_name && this.user?.profile?.last_name
          ? `${this.user.profile.first_name} ${this.user.profile.last_name}`
          : this.user?.email;
      },
      bottomNavLinks() {
        if (this.isAuthenticated ){
          return this.authLinks.filter(x => x.text !== "Blogs").filter(y =>  y.text !== "My Blogs" )
        } else return this.links.filter(link => link.text !== "Blogs")
      },
      authLinks() {
        const links = [
          {text: 'TUTORS', link: '/tutors', icon: '', isImage: false},
          {text: 'LEARNING MATERIALS', link: '/learning', icon: '', isImage: false},
          {text: 'QUESTIONS /PAST PAPERS', link:"/questions", icon: '', isImage: false},
        ]
        return links;
      },
    },
  };
  </script>
  
  <style scoped>
  .active-item {
    background-color: rgba(79, 132, 255, 0.58);
    border-radius: .4em;
  }
  
  .v-list-item:hover {
    background-color: rgba(79, 132, 255, 0.58);
  }
  
  </style>
  
  